import { createAsyncThunk } from '@reduxjs/toolkit';
import type { ApiClient } from '@travel/api-client';
import loggerGenerator from '@travel/logger';
import { apiPath } from 'constants/api';
import type {
  FormConfigQueryParams,
  ReviewAPIResponse,
  ReviewFormConfig,
  ReviewPostQueryParams,
} from './types';
import type { RootState } from 'react-redux';
import { noticeError } from '@travel/tracker';

const logger = loggerGenerator();

export const fetchReviewFormConfig = createAsyncThunk<
  ReviewFormConfig,
  FormConfigQueryParams,
  { state: RootState; extra: { apiClient: ApiClient } }
>('reviewConfig/fetch', async (payload, { getState, extra: { apiClient }, rejectWithValue }) => {
  const {
    authCode: { item },
  } = getState();

  if (!item?.token) return;

  try {
    const data = await apiClient.get(apiPath.getReviewConfig.pathname, { values: payload });

    return data;
  } catch (error) {
    logger.error('Error fetching config:', error);
    noticeError('Error fetching config:', error);

    return rejectWithValue(error);
  }
});

export const postNewReview = createAsyncThunk<
  ReviewAPIResponse,
  ReviewPostQueryParams,
  { extra: { apiClient: ApiClient } }
>('reviewConfig/post', async (payload, { extra: { apiClient }, rejectWithValue }) => {
  try {
    const data = await apiClient.post(apiPath.postReview.pathname(), { values: payload });

    return data;
  } catch (error) {
    noticeError('Error Posting Review:', error);

    return rejectWithValue(error);
  }
});

export const updateReview = createAsyncThunk<
  ReviewAPIResponse,
  {
    reviewId: string;
    review: ReviewPostQueryParams;
  },
  { extra: { apiClient: ApiClient } }
>('reviewConfig/update', async (payload, { extra: { apiClient }, rejectWithValue }) => {
  try {
    const data = await apiClient.patch(apiPath.editReview.pathname(payload.reviewId), {
      values: payload.review,
    });

    return data;
  } catch (error) {
    noticeError('Error Updating Review:', error);

    return rejectWithValue(error);
  }
});
